import { SvgIcon } from '@mui/material';

export default function VisibilityOffIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20.9 20.8"
      style={{ width: `22px`, height: `22px`, color: `white`, ...props.style }}
    >
      <g>
        <path
          d="M8.8,4.1c0.6-0.1,1.1-0.2,1.7-0.2c5.1,0,8.4,5.3,9.1,6.5c-0.5,0.9-1.1,1.7-1.7,2.5c-0.2,0.2-0.1,0.5,0.1,0.7
          c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3-0.1,0.4-0.2c0.8-0.9,1.4-1.9,2-2.9c0.1-0.1,0.1-0.3,0-0.5c-0.1-0.3-3.7-7.3-10.1-7.3h0
          c-0.6,0-1.3,0.1-1.9,0.2C8.2,3.1,8.1,3.4,8.1,3.7C8.2,3.9,8.5,4.1,8.8,4.1L8.8,4.1z"
        />
        <path
          d="M20.5,19.7L1.2,0.4C1,0.2,0.7,0.2,0.5,0.4s-0.2,0.5,0,0.7l4.1,4c-1.7,1.4-3.1,3.1-4.1,5
          c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.3,3.7,7.3,10.1,7.3l0,0c1.9,0,3.6-0.6,5.1-1.6l4.1,4.1c0.1,0.1,0.2,0.1,0.4,0.1s0.3,0,0.4-0.1
          C20.7,20.2,20.7,19.9,20.5,19.7L20.5,19.7z M8.6,9.3l2.9,2.9C10.8,12.7,9.7,12.7,9,12C8.2,11.3,8.1,10.1,8.6,9.3L8.6,9.3z
          M10.5,16.9L10.5,16.9c-5.1,0-8.4-5.3-9.1-6.5c1-1.8,2.3-3.3,3.8-4.5l2.7,2.7c-1,1.3-0.8,3.1,0.3,4.2c0.6,0.6,1.4,0.8,2.1,0.8
          c0.7,0,1.3-0.2,1.9-0.6l2.6,2.6C13.6,16.4,12.1,16.9,10.5,16.9z"
        />
      </g>
    </SvgIcon>
  );
}
